<template>
  <div class="flex full-width">
    <h2 class="filters-title">Due: </h2>
    <div class="date-picker-container">
      <el-date-picker
        v-model="selectedDate"
        class="date-picker"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        format="dd/MM/yyyy"
        value-format="yyyy-MM-dd"
        :picker-options="datePickerOptions"
        @change="reloadList">
      </el-date-picker>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      datePickerOptions: {
        shortcuts: [{
          text: 'in a week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + (3600 * 1000 * 24 * 7));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: 'in a month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + (3600 * 1000 * 24 * 30));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: 'in 3 months',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + (3600 * 1000 * 24 * 90));
            picker.$emit('pick', [start, end]);
          },
        },{
          text: 'Past due',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() - (3600 * 1000 * 24 * 960));
            picker.$emit('pick', [end, start]);
          },
        }],
      },
      selectedDate: [],
    };
  },
  computed: {
    ...mapGetters({
      getReceivablesSelectedDueDates: 'getReceivablesSelectedDueDates',
    }),
  },
  mounted() {
    this.selectedDate = this.getReceivablesSelectedDueDates;
  },
  methods: {
    ...mapActions({
      setReceivablesSelectedDueDates: 'setReceivablesSelectedDueDates',
      getSearchedReceivableTransactionsData: 'getSearchedReceivableTransactionsData',
    }),
    reloadList() {
      if (this.selectedDate) {
        this.setReceivablesSelectedDueDates(this.selectedDate);
      } else {
        this.setReceivablesSelectedDueDates([]);
      }
      this.getSearchedReceivableTransactionsData();
    },
  },
};
</script>

<style lang="scss" scoped>
  .date-picker-container{
    width:100%;
    .date-picker{
      width: 98%;
      float: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/receivables/partials/receivables-filters/partials/ReceivablesByDate.vue